import { IStateCart, IPricing } from "@/apps/merchant3/models/IStateCart";
import { EContract } from "@/apps/merchant3/models/IStateContract";
import { IOptionDropdown } from "@/types/dropdown";

const mutations = {
  SET_CART: (state: IStateCart, payload: IStateCart): void => {
    Object.keys(payload).forEach((key) => (state[key] = payload[key]));
  },
  RESET_CART: (state: IStateCart): void => {
    Object.keys(state).forEach((key) => (state[key] = null));
  },
  SET_CART_TAG: (state: IStateCart, payload: string): void => {
    state.cartTag = payload;
  },
  SET_SELECTED_OFFER: (state: IStateCart, payload: number): void => {
    state.months = payload;
  },

  SET_SELECTED_IMAGE_URL: (state: IStateCart, payload: string | null): void => {
    state.deviceImageUrl = payload;
  },

  SET_RETAIL_PRICE: (state: IStateCart, payload: number): void => {
    state.priceWithSalesTax = payload;
  },

  SET_DOWN_PAYMENT: (state: IStateCart, payload: number): void => {
    state.downPayment = payload;
  },

  SET_HAS_RECEIVED_WELCOME_CALL: (
    state: IStateCart,
    payload: EContract
  ): void => {
    state.hasReceivedWelcomeCall = payload;
  },

  SET_CONTRACT_SIGNED_TIMESTAMP: (state: IStateCart, payload: string): void => {
    state.contractSignedTimestamp = payload;
  },

  SET_WELCOME_CALL_REQUIRED: (state: IStateCart, payload: EContract): void => {
    state.welcomeCallRequired = payload;
  },

  SET_ATTEMPTS: (state: IStateCart, payload: number): void => {
    state.attempts = payload;
  },

  SET_CONTRACT_VERBALLY_ACCEPTED: (
    state: IStateCart,
    payload: EContract
  ): void => {
    state.contractVerballyAccepted = payload;
  },

  LOAD_DEVICE_BRANDS: (
    state: { deviceBrands: IOptionDropdown[] },
    payload: IOptionDropdown[]
  ): void => {
    state.deviceBrands = payload;
  },

  UPDATE_PRICING: (state: { pricing: IPricing }, payload: IPricing): void => {
    state.pricing = payload;
  },

  SET_NEW_PHONE_NUMBER: (state: IStateCart, payload: string | null): void => {
    state.newPhoneNumber = payload;
  },

  SET_DEVICE_PHONE_NUMBER: (state: IStateCart, payload: string): void => {
    state.devicePhoneNumber = payload;
  },

  SET_ACTIVATION_METHOD: (state: IStateCart, payload: string | null): void => {
    state.activationMethod = payload;
  },

  SET_CURRENT_PAGE: (state: IStateCart, payload: string): void => {
    state.currentPage = payload;
  },

  SET_IMEI: (state: IStateCart, payload: number | null): void => {
    state.imei = payload;
  },

  SET_STEP: (state: IStateCart, payload: string): void => {
    state.step = payload;
  },
  SET_INCODE_ONBOARD_COMPLETE: (state: IStateCart, payload: boolean): void => {
    state.incodeOnboardComplete = payload;
  },
  SET_INCODE_ONBOARD_STATUS: (state: IStateCart, payload: string): void => {
    state.incodeOnboardStatus = payload;
  },
  SET_ONE_TIME_PASSWORD: (
    state: IStateCart,
    payload: { otp: string; currentBalance: number }
  ): void => {
    state.oneTimePassword = {
      oneTimePassword: payload.otp,
      balance: payload.currentBalance,
    };
  },
  SET_UNIQUE_REQUESTS: (state: IStateCart, payload: string[]): void => {
    state.uniqueRequestList = payload;
  },
};

export default mutations;
